export const selectPaymentStatusColor = (status: string | undefined) => {
  switch (status) {
    case 'paid':
      return 'success';
    case 'pending':
      return 'info';
    case 'refund':
      return 'warning';
    case 'failed':
      return 'error';
    default:
      return 'error';
  }
};